import React from 'react';


function FeaturedItemsHeading(props) {
  const { isTitleForHome, showHeading } = props;

  if (!showHeading) {
    return null;
  }

  if (isTitleForHome === '/home') {
    return (
      <div className="news-title">
        <h3>
          <a href="/featured-content">FEATURED CONTENT</a>
        </h3>
      </div>
    );
  }

  return <h1 className="h1 title">Featured Content</h1>;
}

export default FeaturedItemsHeading;
